export default __webpack_public_path__ + "static/media/client-17.8576a7d8.png";